module.exports = __webpack_public_path__ + "media/images/twitter-fe06d572bd13680e66f4d31fc7cf1832.svg";